import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const CHOOSE = 'CCC'
export const GROUPS_TO_APPEAR = 'survey to appear'
export const ADD_TAG = 'ADD TAG'

export default {
  [PORTUGUESE]: {
    [CHOOSE]: 'Escolha',
    [GROUPS_TO_APPEAR]: 'grupos a serem sorteados',
    [ADD_TAG]: 'Adicionar tag',
  },

  [ENGLISH]: {
    [CHOOSE]: 'Choose',
    [GROUPS_TO_APPEAR]: 'groups to be shown',
    [ADD_TAG]: 'Add tag',
  },

  [SPANISH]: {
    [CHOOSE]: 'Elegir',
    [GROUPS_TO_APPEAR]: 'grupos a mostrar',
    [ADD_TAG]: 'add tag',
  },
}
